export default __webpack_public_path__ + "static/media/team3.622fc335.jpeg";